<template>
  <div class="feature-card w-[500px] surface-100 rounded-lg px-4 py-4 flex flex-col">
    <h3 class="text-xl md:text-2xl font-bold text-center mb-2">
      {{ title }}
    </h3>

    <div class="flex flex-col lg:flex-row items-start flex-1 mb-2">
      <div class="lg:w-2/3">
        <ul class="space-y-4">
          <li v-for="(point, index) in points" :key="index" class="flex items-start mt-2 md:mt-3">
            <i class="pi pi-check mt-1 flex-shrink-0"></i>
            <p class="ml-2 text-base md:text-lg leading-snug text-justify">
              {{ point }}
            </p>
          </li>
        </ul>
      </div>

      <div
        :class="[
          'mt-4 lg:mt-0 lg:ml-4 flex justify-center items-center',
          isMobile ? 'w-full' : 'lg:w-1/3',
        ]"
      >
        <img :src="image" :alt="title" class="w-full h-auto max-h-[300px] object-contain rounded" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'

interface Props {
  title: string
  points: string[]
  image: string
}
const props = defineProps<Props>()

const isMobile = ref(window.innerWidth < 1024)

const updateWidth = () => {
  isMobile.value = window.innerWidth < 1024
}

onMounted(() => {
  window.addEventListener('resize', updateWidth)
})

onUnmounted(() => {
  window.removeEventListener('resize', updateWidth)
})
</script>

<style scoped>
.feature-card {
  min-height: 42vh;
}
</style>
